import { useQuery } from '@tanstack/react-query';
import { getActionRequiredOrders } from '../api/client';

export function useActionRequired(pollingEnabled?: boolean) {
  return useQuery({
    queryKey: ['action-required'],
    queryFn: getActionRequiredOrders,
    staleTime: pollingEnabled ? 0 : 30 * 1000,
    refetchInterval: pollingEnabled ? 3000 : false,
  });
}
